import type { StartRealtimeVoiceCallArgs } from './start-realtime-voice-call';
import { createRealtimeVoiceCoreTools } from './realtime-voice-core-tools';
import { createRealtimeVoiceNavigationTools } from './realtime-voice-navigation-tools';
import { createRealtimeVoiceQuestionnaireTool } from './realtime-voice-questionnaire-tool';
import { createRealtimeVoiceThreadMessagingTool } from './realtime-voice-thread-messaging-tools';
import { createRealtimeVoiceWorkspaceTool } from './realtime-voice-workspace-tool';

export function createRealtimeVoiceTools(
  args: StartRealtimeVoiceCallArgs,
  leaseSessionId: string
) {
  const toolContext = {
    ...args.navigationActions,
    orgThreadId: args.orgThreadId,
    leaseSessionId,
    // Final accounting keeps the lifecycle identity. Closing calls cannot
    // apply delayed tool effects or report their results to the user.
    isCurrentCall: () =>
      args.isCurrentCall() && !args.refs.sessionRef.current?.isClosing,
    isSourceChatVisible: () => args.refs.sourceChatVisibleRef.current,
    orgChatRef: args.refs.delegationTargetRef,
    activeOperationRef: args.responses.activeOperationRef,
    claimedOperationsRef: args.responses.claimedOperationsRef,
    getRealtimeChatContext: args.actions.getChatContext,
    sendChatMessage: args.actions.sendChatMessage,
    getOffPageQuestion: args.actions.getOffPageQuestion,
    runNativeWebSearch: args.actions.runNativeWebSearch,
    runQuickResearch: args.actions.runQuickResearch,
    answerAskQuestion: args.actions.answerAskQuestion,
    answerAskQuestionGroup: args.actions.answerAskQuestionGroup,
    addVoiceDelegationReceipt: args.receipts.addReceipt,
    updateVoiceDelegationReceipt: args.receipts.updateReceipt,
    finishRealtimeToolResult: args.responses.finishToolResult,
    askQuestionCopy: args.askQuestionCopy,
  };
  const coreTools = createRealtimeVoiceCoreTools(toolContext);
  const navigationTools = createRealtimeVoiceNavigationTools(toolContext);
  return [
    coreTools.chatContextTool,
    navigationTools.findNavigationTargetsTool,
    navigationTools.navigateUiTool,
    createRealtimeVoiceWorkspaceTool(toolContext),
    createRealtimeVoiceThreadMessagingTool(toolContext),
    createRealtimeVoiceQuestionnaireTool(toolContext),
    coreTools.nativeWebSearchTool,
    coreTools.quickResearchTool,
    coreTools.delegateTool,
  ];
}
